import { Injectable } from '@angular/core';
import { Installation } from '../models/Installation';
import { InstallationData } from '../models/InstallationData';
import { ContactUser } from '../models/ContactUser';
import { NewContactData } from '../models/NewContactData';
import { Camera } from '../models/Camera';
import { BillingInfo } from '../models/BillingInfo';
import { UserLogin } from '../models/UserLogin';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariablesService {

  constructor() { }
  public TOKEN_KEY = 'auth-token';
  public TOKEN_EXPIRATION_KEY = 'valid_until';
  public TOKEN_EXPIRATION_KEY_PREAUTH = 'valid_until_preauth';
  public AUTH_KEY = 'auth';
  // public RECOVERY_EMAIL = 'recovery_email';
  public SEE_TOUCHID = 'see_touchID';
  public USERS_LOGIN = 'users_login';
  public lang = 'es';
  public currentInstallation: Installation = null;
  public infInstallation: InstallationData;
  public billingInfo: BillingInfo;
  public contactsUserInstallation: ContactUser [] = [];
  public EXPIRATION_AUTH = 'expiration_auth';
  public CONF_INSTALLATIONS = 'conf_installations';
  public idNotification = 0;
  public modalLoaded = 'empty';
  public emergencyServices = [];
  public newContactData = new NewContactData();
  public versionCode:any;
  public CAMERA_VIDEO_CLIENT = 'cam_video_client';
  public sessionStartTime: Date;
  public activeGeofencesIDs = [];
  public cronTokenWeb: number = 0;
  public isCurrentUserMaster = false;
  public user: UserLogin = null;
  public ratingAvailable = false;
  public isGeofenceFunctioning = false;
  public geofenceProblems = true;
  public notificationData = null;
  public CARDS_NEWS = 'cards_news';
  public VIDEO_LIVE_TIME = 'video_live_time';
  public NPS_VIEW = 'nps_view';
  public supportChatID = 0;
  public craChatID = 0;
  public finishCountDownEvent: Subscription;
}
